import React, {useContext} from 'react';
import Accordion from './Filters/Accordion';
import PriceRange from './Filters/PriceRange';
// import RoomCount from './Filters/RoomCount';
import {AppContext} from '../contexts/AppContext';
import {translate} from '../helpers/base';
import ActiveFilters, {useHasActiveFilters} from './Common/ActiveFilters';
import Pets from './Filters/Pets';
import AccessibleFacilities from './Filters/AccessibleFacilities';
import clsx from 'clsx';

const Filters = () => {

    const {
        filters,
        selectedFilters,
        subFilters,
        setIsFilterOverlayVisible,
        handleFilterChange,
        handlePriceRangeChange,
        handleAccommodationTypeChange,
        hasResultsWithPrices,
        isMobile
    } = useContext(AppContext);

    const selectedAccommodationType = selectedFilters.accoType || 0;

    // const [subFilters, setSubFilters] = useState({});
    const hasActiveFilters = useHasActiveFilters();

    const handleCloseButtonClick = () => {
        setIsFilterOverlayVisible(false);
    };

    /*
    const handleRoomCountChange = (count) => {
        setSelectedFilters(prev => ({
            ...prev,
            beds: count.beds,
            bedrooms: count.bedrooms
        }));
    };*/

    const renderFilterOptions = (filterType, filter) => (
        <div className="accordion--filter-section" key={filterType}>
            {filter.options.map((option) => {
                const isChecked = selectedFilters[filterType] ? selectedFilters[filterType].includes(option.id) : false;
                return (
                    <div className="checkbox" key={filter.label + option.id}>
                        <label>
                            <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => handleFilterChange(filterType, option.id, !isChecked)}
                            />
                            <span></span>
                            {option.theme && <i className={clsx('world', 'theme--' + option.theme)}></i>}
                            <div>{option.label}</div>
                        </label>
                    </div>
                )
            })}
        </div>
    );

    const getFilterCount = (filterType, filter) => {
        const selected = selectedFilters[filterType];
        if (!selected || !Array.isArray(selected)) {
            return 0;
        }

        const groupOptionIds = filter.options.map(opt => opt.id);
        return selected.filter(id => groupOptionIds.includes(id)).length;
    };

    return (
        <div className="accordion--inner">
            <div className="accordion--header-mobile">
                <div className="accordion--header-mobile--title">
                    Filter <label className="overlay-close" onClick={handleCloseButtonClick}></label>
                </div>
                {isMobile && hasActiveFilters && <div className="accommodation-overview--filter-pills">
                    <div className="pill-container">
                        <ActiveFilters/>
                    </div>
                </div>}
            </div>

            {filters.accommodationType && <div className="form-group accommodation-type">
                {!selectedAccommodationType && <span>{translate('accommodation-overview.filter.accommodationType.hint')}</span>}
                <label htmlFor={'accommodationTypeSelect'}>{translate('accommodation-overview.filter.accommodationType.label')}</label>
                <select
                    id={'accommodationTypeSelect'}
                    value={selectedAccommodationType}
                    onChange={(e) => handleAccommodationTypeChange(parseInt(e.target.value, 10))}
                >
                    <option value="0">{translate('accommodation-overview.filter.accommodationType.all')}</option>
                    {filters.accommodationType.options.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>}
            {hasResultsWithPrices && <div className="accordion--filter-section">
                <PriceRange onChange={handlePriceRangeChange}/>
            </div>}
                {/*
            <div className="accordion--filter-section">
                <RoomCount onChange={handleRoomCountChange} />
            </div>*/}
            {Object.values(filters.global).map((filter, index) => (
                <Accordion key={filter.name + index} title={filter.label} filterCount={getFilterCount(filter.name, filter)} open={isMobile}>
                    {renderFilterOptions(filter.name, filter)}
                </Accordion>
            ))}
            {Object.entries(subFilters).map(([index, filter]) => (
                <Accordion key={filter.name + index} title={filter.label} filterCount={getFilterCount(filter.name, filter)} open={isMobile}>
                    {renderFilterOptions(filter.name, filter)}
                </Accordion>
            ))}
            <Accordion title={translate('accommodation-overview.filter.misc.label')} open={true} className="accordion--misc">
                <div className="accordion--filter-section">
                    <Pets />
                    <AccessibleFacilities />
                </div>
            </Accordion>
        </div>
    );
};

export default Filters;